"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _useSnackbar = _interopRequireDefault(require("./useSnackbar"));
var _ClickAwayListener = _interopRequireDefault(require("../ClickAwayListener"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _Grow = _interopRequireDefault(require("../Grow"));
var _SnackbarContent = _interopRequireDefault(require("../SnackbarContent"));
var _snackbarClasses = require("./snackbarClasses");
var _useSlot = _interopRequireDefault(require("../utils/useSlot"));
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, anchorOrigin = ownerState.anchorOrigin;
    var slots = {
        root: [
            'root',
            "anchorOrigin".concat((0, _capitalize.default)(anchorOrigin.vertical)).concat((0, _capitalize.default)(anchorOrigin.horizontal))
        ]
    };
    return (0, _composeClasses.default)(slots, _snackbarClasses.getSnackbarUtilityClass, classes);
};
var SnackbarRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles["anchorOrigin".concat((0, _capitalize.default)(ownerState.anchorOrigin.vertical)).concat((0, _capitalize.default)(ownerState.anchorOrigin.horizontal))]
        ];
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center',
        variants: [
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchorOrigin.vertical === 'top';
                },
                style: _define_property({
                    top: 8
                }, theme.breakpoints.up('sm'), {
                    top: 24
                })
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchorOrigin.vertical !== 'top';
                },
                style: _define_property({
                    bottom: 8
                }, theme.breakpoints.up('sm'), {
                    bottom: 24
                })
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchorOrigin.horizontal === 'left';
                },
                style: _define_property({
                    justifyContent: 'flex-start'
                }, theme.breakpoints.up('sm'), {
                    left: 24,
                    right: 'auto'
                })
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchorOrigin.horizontal === 'right';
                },
                style: _define_property({
                    justifyContent: 'flex-end'
                }, theme.breakpoints.up('sm'), {
                    right: 24,
                    left: 'auto'
                })
            },
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return ownerState.anchorOrigin.horizontal === 'center';
                },
                style: _define_property({}, theme.breakpoints.up('sm'), {
                    left: '50%',
                    right: 'auto',
                    transform: 'translateX(-50%)'
                })
            }
        ]
    };
}));
var Snackbar = /*#__PURE__*/ React.forwardRef(function Snackbar(inProps, ref) {
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    var theme = (0, _zeroStyled.useTheme)();
    var defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    var action = props.action, tmp = props.anchorOrigin, _ref = tmp === void 0 ? {
        vertical: 'bottom',
        horizontal: 'left'
    } : tmp, vertical = _ref.vertical, horizontal = _ref.horizontal, _props_autoHideDuration = props.autoHideDuration, autoHideDuration = _props_autoHideDuration === void 0 ? null : _props_autoHideDuration, children = props.children, className = props.className, ClickAwayListenerPropsProp = props.ClickAwayListenerProps, ContentPropsProp = props.ContentProps, _props_disableWindowBlurListener = props.disableWindowBlurListener, disableWindowBlurListener = _props_disableWindowBlurListener === void 0 ? false : _props_disableWindowBlurListener, message = props.message, onBlur = props.onBlur, onClose = props.onClose, onFocus = props.onFocus, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, open = props.open, resumeHideDuration = props.resumeHideDuration, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, TransitionComponentProp = props.TransitionComponent, _props_transitionDuration = props.transitionDuration, transitionDuration = _props_transitionDuration === void 0 ? defaultTransitionDuration : _props_transitionDuration, tmp1 = props.TransitionProps, _ref1 = tmp1 === void 0 ? {} : tmp1, onEnter = _ref1.onEnter, onExited = _ref1.onExited, TransitionPropsProp = _object_without_properties(props.TransitionProps, [
        "onEnter",
        "onExited"
    ]), other = _object_without_properties(props, [
        "action",
        "anchorOrigin",
        "autoHideDuration",
        "children",
        "className",
        "ClickAwayListenerProps",
        "ContentProps",
        "disableWindowBlurListener",
        "message",
        "onBlur",
        "onClose",
        "onFocus",
        "onMouseEnter",
        "onMouseLeave",
        "open",
        "resumeHideDuration",
        "slots",
        "slotProps",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponentProp,
        transitionDuration: transitionDuration
    });
    var classes = useUtilityClasses(ownerState);
    var _ref2 = (0, _useSnackbar.default)(_object_spread({}, ownerState)), getRootProps = _ref2.getRootProps, onClickAway = _ref2.onClickAway;
    var _React_useState = _sliced_to_array(React.useState(true), 2), exited = _React_useState[0], setExited = _React_useState[1];
    var handleExited = function(node) {
        setExited(true);
        if (onExited) {
            onExited(node);
        }
    };
    var handleEnter = function(node, isAppearing) {
        setExited(false);
        if (onEnter) {
            onEnter(node, isAppearing);
        }
    };
    var externalForwardedProps = {
        slots: _object_spread({
            transition: TransitionComponentProp
        }, slots),
        slotProps: _object_spread({
            content: ContentPropsProp,
            clickAwayListener: ClickAwayListenerPropsProp,
            transition: TransitionPropsProp
        }, slotProps)
    };
    var _ref3 = _sliced_to_array((0, _useSlot.default)('root', {
        ref: ref,
        className: [
            classes.root,
            className
        ],
        elementType: SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: _object_spread({}, externalForwardedProps, other),
        ownerState: ownerState
    }), 2), Root = _ref3[0], rootProps = _ref3[1];
    var _ref4 = (0, _useSlot.default)('clickAwayListener', {
        elementType: _ClickAwayListener.default,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: function(handlers) {
            return {
                onClickAway: function() {
                    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
                        params[_key] = arguments[_key];
                    }
                    var _handlers_onClickAway;
                    var _handlers_onClickAway1;
                    (_handlers_onClickAway1 = handlers.onClickAway) === null || _handlers_onClickAway1 === void 0 ? void 0 : (_handlers_onClickAway = _handlers_onClickAway1).call.apply(_handlers_onClickAway, [
                        handlers
                    ].concat(_to_consumable_array(params)));
                    onClickAway.apply(void 0, _to_consumable_array(params));
                }
            };
        },
        ownerState: ownerState
    }), _ref5 = _sliced_to_array(_ref4, 2), ClickAwaySlot = _ref5[0], _ref_ = _ref5[1], clickAwayOwnerStateProp = _ref_.ownerState, clickAwayListenerProps = _object_without_properties(_ref4[1], [
        "ownerState"
    ]);
    var _ref6 = _sliced_to_array((0, _useSlot.default)('content', {
        elementType: _SnackbarContent.default,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            message: message,
            action: action
        },
        ownerState: ownerState
    }), 2), ContentSlot = _ref6[0], contentSlotProps = _ref6[1];
    var _ref7 = _sliced_to_array((0, _useSlot.default)('transition', {
        elementType: _Grow.default,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: function(handlers) {
            return {
                onEnter: function() {
                    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
                        params[_key] = arguments[_key];
                    }
                    var _handlers_onEnter;
                    var _handlers_onEnter1;
                    (_handlers_onEnter1 = handlers.onEnter) === null || _handlers_onEnter1 === void 0 ? void 0 : (_handlers_onEnter = _handlers_onEnter1).call.apply(_handlers_onEnter, [
                        handlers
                    ].concat(_to_consumable_array(params)));
                    handleEnter.apply(void 0, _to_consumable_array(params));
                },
                onExited: function() {
                    for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
                        params[_key] = arguments[_key];
                    }
                    var _handlers_onExited;
                    var _handlers_onExited1;
                    (_handlers_onExited1 = handlers.onExited) === null || _handlers_onExited1 === void 0 ? void 0 : (_handlers_onExited = _handlers_onExited1).call.apply(_handlers_onExited, [
                        handlers
                    ].concat(_to_consumable_array(params)));
                    handleExited.apply(void 0, _to_consumable_array(params));
                }
            };
        },
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            direction: vertical === 'top' ? 'down' : 'up'
        },
        ownerState: ownerState
    }), 2), TransitionSlot = _ref7[0], transitionProps = _ref7[1];
    // So we only render active snackbars.
    if (!open && exited) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClickAwaySlot, _object_spread_props(_object_spread({}, clickAwayListenerProps, slots.clickAwayListener && {
        ownerState: clickAwayOwnerStateProp
    }), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, _object_spread_props(_object_spread({}, rootProps), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionSlot, _object_spread_props(_object_spread({}, transitionProps), {
                children: children || /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContentSlot, _object_spread({}, contentSlotProps))
            }))
        }))
    }));
});
process.env.NODE_ENV !== "production" ? Snackbar.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */ action: _propTypes.default.node,
    /**
   * The anchor of the `Snackbar`.
   * On smaller screens, the component grows to occupy all the available width,
   * the horizontal alignment is ignored.
   * @default { vertical: 'bottom', horizontal: 'left' }
   */ anchorOrigin: _propTypes.default.shape({
        horizontal: _propTypes.default.oneOf([
            'center',
            'left',
            'right'
        ]).isRequired,
        vertical: _propTypes.default.oneOf([
            'bottom',
            'top'
        ]).isRequired
    }),
    /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   * @default null
   */ autoHideDuration: _propTypes.default.number,
    /**
   * Replace the `SnackbarContent` component.
   */ children: _propTypes.default.element,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * Props applied to the `ClickAwayListener` element.
   * @deprecated Use `slotProps.clickAwayListener` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ ClickAwayListenerProps: _propTypes.default.object,
    /**
   * Props applied to the [`SnackbarContent`](https://mui.com/material-ui/api/snackbar-content/) element.
   * @deprecated Use `slotProps.content` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ ContentProps: _propTypes.default.object,
    /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   * @default false
   */ disableWindowBlurListener: _propTypes.default.bool,
    /**
   * When displaying multiple consecutive snackbars using a single parent-rendered
   * `<Snackbar/>`, add the `key` prop to ensure independent treatment of each message.
   * For instance, use `<Snackbar key={message} />`. Otherwise, messages might update
   * in place, and features like `autoHideDuration` could be affected.
   */ key: function() {
        return null;
    },
    /**
   * The message to display.
   */ message: _propTypes.default.node,
    /**
   * @ignore
   */ onBlur: _propTypes.default.func,
    /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {React.SyntheticEvent<any> | Event} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`, or `"escapeKeyDown"`.
   */ onClose: _propTypes.default.func,
    /**
   * @ignore
   */ onFocus: _propTypes.default.func,
    /**
   * @ignore
   */ onMouseEnter: _propTypes.default.func,
    /**
   * @ignore
   */ onMouseLeave: _propTypes.default.func,
    /**
   * If `true`, the component is shown.
   */ open: _propTypes.default.bool,
    /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */ resumeHideDuration: _propTypes.default.number,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        clickAwayListener: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.shape({
                children: _propTypes.default.element.isRequired,
                disableReactTree: _propTypes.default.bool,
                mouseEvent: _propTypes.default.oneOf([
                    'onClick',
                    'onMouseDown',
                    'onMouseUp',
                    'onPointerDown',
                    'onPointerUp',
                    false
                ]),
                onClickAway: _propTypes.default.func,
                touchEvent: _propTypes.default.oneOf([
                    'onTouchEnd',
                    'onTouchStart',
                    false
                ])
            })
        ]),
        content: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        root: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        transition: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: _propTypes.default.shape({
        clickAwayListener: _propTypes.default.elementType,
        content: _propTypes.default.elementType,
        root: _propTypes.default.elementType,
        transition: _propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */ TransitionComponent: _propTypes.default.elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ transitionDuration: _propTypes.default.oneOfType([
        _propTypes.default.number,
        _propTypes.default.shape({
            appear: _propTypes.default.number,
            enter: _propTypes.default.number,
            exit: _propTypes.default.number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */ TransitionProps: _propTypes.default.object
} : void 0;
var _default = exports.default = Snackbar;
